module.exports = __webpack_public_path__ + "static/media/sia-env.4e0e160b.png";